import PlantelRow from "./PlantelRow";
import { Icon } from "@iconify/react/dist/iconify.js";

const PlantelsTable = ({ plantels, search }) => {
  if (!plantels || plantels.length === 0) {
    return (
      <div className="text-center py-5">
        <Icon
          icon={search ? "mdi:magnify-remove-outline" : "mdi:office-building-outline"}
          width="64"
          className="text-secondary-light mb-3"
        />
        <p className="text-secondary-light mb-1 fw-medium">
          {search
            ? "No se encontraron planteles"
            : "No hay planteles para mostrar"}
        </p>
        {search && (
          <p className="text-secondary-light text-sm">
            Intenta con otra búsqueda
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="table-responsive scroll-sm">
      <table className="table bordered-table mb-0" style={{ minWidth: "800px" }}>
        <thead>
          <tr>
            <th scope="col" style={{ minWidth: "180px" }}>Nombre</th>
            <th scope="col" style={{ minWidth: "120px" }}>Clave</th>
            <th scope="col" style={{ minWidth: "250px" }}>Escuela</th>
            <th scope="col" style={{ minWidth: "100px" }}>Estatus</th>
            <th scope="col" style={{ minWidth: "80px" }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {plantels.map((plantel) => (
            <PlantelRow key={plantel.id} plantel={plantel} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlantelsTable;
